import { Component, OnInit, Type, ComponentFactoryResolver, ViewEncapsulation , ViewChild, ViewContainerRef, OnDestroy, } from '@angular/core';
import { Roles } from '../../../models/enums';
import { Subscription } from 'rxjs';
import { IComponetByRole, getComponentByRole } from '../../../helpers/component-by-role';
import { FixturesLeagueTableComponent } from '../fixtures-league-table/fixtures-league-table.component';
import { FixturesBroadcastersTableComponent } from '../fixtures-broadcasters-table/fixtures-broadcasters-table.component';
import { FixturesClubsTableComponent } from '../fixtures-clubs-table/fixtures-clubs-table.component';
import { AppState } from '../../../store/app.state';
import { Store } from '@ngrx/store';
import { IUserRole } from '../../../models/user.model';

@Component({
  selector: 'app-fixtures-wrapper',
  templateUrl: './fixtures-wrapper.component.html'  
})
export class FixturesWrapperComponent implements OnInit, OnDestroy {

  @ViewChild('dynamicComponent', { read: ViewContainerRef, static: true }) fixtureRef;
  interval: any;
  userInfo: Subscription;
  role: Roles;

  private components: IComponetByRole[] = [
    { role: Roles.League, component: FixturesLeagueTableComponent},
    { role: Roles.Admin, component: FixturesLeagueTableComponent},
    { role: Roles.Broadcaster, component: FixturesBroadcastersTableComponent},
    { role: Roles.PLPBroadcaster, component: FixturesBroadcastersTableComponent},
    { role: Roles.Club, component: FixturesClubsTableComponent}
  ];

  constructor(private componentFactoryResolver: ComponentFactoryResolver, private store: Store<AppState>) { }

  ngOnInit() {

    this.userInfo = this.store
      .select(state => state.user.currentUser)
      .subscribe(u => {
        if (u.role) {
          this.role = u.role;
          this.loadComponent(this.role);
        }
      });
  }

  loadComponent(role) {
    const factory = this.componentFactoryResolver.resolveComponentFactory(getComponentByRole(this.components, role));
    this.fixtureRef.clear();
    const ref = this.fixtureRef.createComponent(factory);
    ref.changeDetectorRef.detectChanges();
  }

  ngOnDestroy(): void {
    if (this.userInfo) {
      this.userInfo.unsubscribe();
    }
  }

}
